module.exports = __webpack_public_path__ + "img/2.34ee5c4a.jpg";